import { combineReducers } from 'redux';
import authentication from "./Authentication/authentication";
import addPage from "./AddPage/addPage";
import localStore from "./LocalStore/localStore";

const rootReducer = combineReducers({
   authentication,
   addPage,
   localStore
  });
  
  export default rootReducer;